import React from "react";
import { Popover, List, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import FilterIcon from "pages/flyer/builder/drawer/components/Primitives/icons/FilterIcon";
import cn from "classnames";

interface InputFilterProps {
  setPhotos: (photos: any[]) => void;
  setPage: (page: number) => void;
  setOrientation: (orientation: string) => void;
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  anchorEl: HTMLElement | null;
  orientation: string;
}

const InputFilter = ({ setPhotos, setPage, setOrientation, setAnchorEl, anchorEl, orientation }: InputFilterProps) => {
  const classes = useStyles();

  const handleOrientationSelect = (value: string) => {
    setOrientation(value);
    setAnchorEl(null);
  };

  const optionsOrientation = [
    { label: "Square", value: "squarish" },
    { label: "Portrait", value: "portrait" },
    { label: "Landscape", value: "landscape" },
  ];
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "orientation" : undefined;

  return (
    <div className="">
      <div className={cn("absolute top-0 right-1 cursor-pointer pt-[8px]")} onClick={handleClick}>
        <FilterIcon orientation={orientation} />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        classes={{ paper: classes.paper }}
      >
        <List className={classes.list}>
          {optionsOrientation.map((option) => (
            <ListItem
              key={option.value}
              button
              onClick={() => handleOrientationSelect(option.value)}
              classes={{ root: classes.listItem }}
            >
              <div
                style={{ border: "1px solid black" }}
                className="w-2 h-2 flex items-center justify-center mr-2 rounded-full"
              >
                {option.value === orientation && <div className="w-1 h-1 rounded-full bg-[#EE4360]"></div>}
              </div>
              <ListItemText
                className={cn(
                  option.value === orientation ? "text-[#273754]" : "text-[#424659]",
                  "capitalize",
                  classes.listItemText
                )}
                primary={<span className={classes.listItemTextPrimary}>{option.label}</span>}
              />
            </ListItem>
          ))}
          <button
            type="button"
            disabled={orientation === ""}
            onClick={() => handleOrientationSelect("")}
            className={cn(orientation === "" ? classes.button : classes.buttonActive)}
          >
            Clear filters
          </button>
        </List>
      </Popover>
    </div>
  );
};

export default InputFilter;

const useStyles = makeStyles({
  paper: {
    borderRadius: "10px !important",
    padding: "0",
    display: "flex",
    justifyContent: "center",
    border: "1px solid #E2E2FC",
    boxShadow: "none",
  },
  list: {
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  button: {
    border: "1px solid #E2E2FC",
    padding: "0.3rem 0.6rem",
    borderRadius: "8px",
    fontSize: "10px",
    marginTop: "4px",
    marginLeft: "16px",
    marginRight: "16px",
    color: "#E2E2FC",
    backgroundColor: "white",
  },
  buttonActive: {
    border: "1px solid #E2E2FC",
    padding: "0.3rem 0.6rem",
    borderRadius: "8px",
    fontSize: "10px",
    marginTop: "4px",
    marginLeft: "16px",
    marginRight: "16px",
    color: "#273754",
    backgroundColor: "#f4f4FC",
  },

  listItem: {
    "&.MuiListItem-root": {
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
    },
  },
  listItemText: {
    fontSize: "12px",
  },
  listItemTextPrimary: {
    fontSize: "12px",
  },
});
